import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../store';
import { ControllerDTO, ControllerItemDTO } from '../types/controller.dto';

export const gatewaysSelector = ({ Device: { gateways } }: AppState) => {
  return gateways;
};

export const controllersSelector = ({ Device: { controllers } }: AppState) => {
  return controllers;
};

export const gatewaysOrderSelector = ({
  Device: { gatewayOrderBy, gatewayOrder },
}: AppState) => {
  return { gatewayOrderBy, gatewayOrder };
};

export const controllersOrderSelector = ({
  Device: { controllerOrderBy, controllerOrder },
}: AppState) => {
  return { controllerOrderBy, controllerOrder };
};

export const sensorsOrderSelector = ({
  Device: { sensorOrderBy, sensorOrder },
}: AppState) => {
  return { sensorOrderBy, sensorOrder };
};

export const controllerSelector = (id: number) =>
  createSelector(controllersSelector, (controllers: ControllerDTO) =>
    controllers.items.find((controller) => controller.id === id)
  );

export const messagesSelector = ({ Device: { messages } }: AppState) => {
  return messages;
};

export const controllerByIdSelector = (controllerId: number) =>
  createSelector([controllersSelector], (controllers: ControllerDTO[]) =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    controllers?.items?.find(
      (controller: ControllerItemDTO) => controller.id === controllerId
    )
  );

export const sensorsSelector = ({ Device: { sensors } }: AppState) => {
  return sensors;
};

export const notesSelector = ({ Device: { notes } }: AppState) => {
  const note: any = [...notes];
  note.sort(
    (a: any, b: any) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
  // note.sort((a: any, b: any) => a.created_at - b.created_at);
  console.log(note);
  return note;
};

export const controllersSelectListSelector = createSelector(
  [controllersSelector],
  (controllers: ControllerDTO) => {
    const idList = [
      ...controllers?.items?.map((item) => ({
        value: item.id,
        label: item.asset_number,
        etage: item?.device_location?.floor,
        area: item?.device_location?.floor_area,
        subArea: item?.device_location?.floor_sub_area,
        devEui: item?.dev_application_eui,
        eui: item?.eui,
      })),
    ];
    return idList;
  }
);

export const controllersListSelector = createSelector(
  [controllersSelector],
  (controllers: ControllerDTO) => {
    const idList = [
      { value: 0, label: 'Select a Controller', placeholder: true },
      ...controllers.items.map((item: any) => ({
        value: item.id,
        label: item.asset_number,
      })),
    ];
    return idList;
  }
);

export const controllerScheduleListSelector = createSelector(
  [controllersSelector],
  (controllers: ControllerDTO) => {
    const idList = [
      { value: 0, label: 'All', labelFr: 'Tout' },
      ...controllers.items.map((item: any) => ({
        value: item.id,
        label: item.asset_number,
      })),
    ];
    return idList;
  }
);
